export const SESSION_STORAGE_KEY = `meterez.auth.session.v3`;
export const PROACTIVE_REFRESH_THRESHOLD = 60 * 60 * 24 * 25; // 25 Days before expiry (30 Day TTL)
export const MANDATORY_REFRESH_THRESHOLD = 30; // 30 Seconds before expiry
